import { Typography } from "@mui/material";
import moment from "moment";
import { useSelector } from "react-redux";

const DiagnosticsView = ({ diagnostics }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  const renderRecord = () => {
    return (diagnostics ?? reqDet?.diagnostics)
      // ?.filter((li) => li?.status?.toLowerCase() === "completed")
      ?.map((li, i) => {
        return (
          <div className="gray-back-con1 mv5" key={Date.now() + i}>
            <div className="flex-row-ali-cen flex-row-wrap">
              <Typography className="txt-semi-bold black fs12">
                Name: {li?.testName}
              </Typography>
              <div className="gray-dot2 mh5" />
              <Typography className="font-medium black4 fs12">
                Type: {li?.type}
              </Typography>
              <div className="gray-dot2 mh5" />
              <Typography className="font-medium black4 fs12">
                Due Date: {moment(li?.dueDate).format("DD MMM YYYY")}
              </Typography>
            </div>
          </div>
        );
      });
  };

  return <div>{renderRecord()}</div>;
};

export default DiagnosticsView;
